import Vue from 'vue'
import Vuex from 'vuex'
import { login, verifyToken, fetchLead, requestDnc, requestDelete } from '@/api/auth'
import router from './router'
import bugsnagClient from './helpers/bugsnag'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      branding: {
        default: {
          colors: {
            navBackground: 'rgba(0,130,202,.7)',
            primaryButtonBackground: '#0082ca',
            primaryFontColor: '#2c3e50',
            footerBackgroundColor: '#000',
            h5Color: '#FFF'
          },
          urls: {
            root: 'https://digitalmediasolutions.com/',
            privacyPolicy: 'https://digitalmediasolutions.com/privacy-policy'
          },
          images: {
            logo: 'dms-logo.png',
            favicon: '/dms-favicon.ico'
          },
          contactInfo: {
            companyName: 'Digital Media Solutions',
            companyNameFull: 'Digital Media Solutions<sup>®</sup>, LLC',
            companyNameShort: 'DMS',
            consumerInquiriesEmail: 'ConsumerInquiries@DMSGroup.com',
            address: 'Digital Media Solutions, 4800 140th Ave N., Suite 101, Clearwater, FL 33762',
            supportNumber: '(800)-290-4010',
            facebook: {
              link: 'https://www.facebook.com/pages/Digital-Media-Solutions/170463923159850',
              image: 'https://digitalmediasolutions.com/themes/dms/assets/images/sm-facebook.png'
            }
          },
          socialMediaLinksHeader: 'Precision Performance Marketing',
          socialMediaLinks: [
            {
              type: 'facebook',
              link: 'https://www.facebook.com/pages/Digital-Media-Solutions/170463923159850',
              image: 'https://digitalmediasolutions.com/themes/dms/assets/images/sm-facebook.png'
            },
            {
              type: 'twitter',
              link: 'https://twitter.com/dmsgrp',
              image: 'https://digitalmediasolutions.com/themes/dms/assets/images/sm-twitter.png'
            },
            {
              type: 'linkedin',
              link: 'https://www.linkedin.com/company/digital-media-solutions-group',
              image: 'https://digitalmediasolutions.com/themes/dms/assets/images/sm-linkedin.png'
            },
            {
              type: 'instagram',
              link: 'https://www.instagram.com/digitalmediasolutions/',
              image: 'https://digitalmediasolutions.com/themes/dms/assets/images/sm-instagram.png'
            }
          ],
          footerLinks: [
            [
              {
                header: 'Digital Media Solutions',
                headerLink: 'https://digitalmediasolutions.com/',
                sublinks: [
                  {
                    display: 'Precision Performance Marketing',
                    link: 'https://digitalmediasolutions.com/performance-marketing'
                  },
                  {
                    display: 'Broadest Digital Marketing Platform',
                    link: 'https://digitalmediasolutions.com/digital-marketing-platform'
                  },
                  {
                    display: 'Measurable Marketing Results',
                    link: 'https://digitalmediasolutions.com/measurable-results'
                  }
                ]
              },
              {
                header: 'People-Based Marketing',
                headerLink: 'https://digitalmediasolutions.com/people-based-marketing',
                sublinks: [
                  {
                    display: 'DMS Consumer Finance',
                    link: 'https://digitalmediasolutions.com/consumer-finance'
                  },
                  {
                    display: 'DMS Education',
                    link: 'https://digitalmediasolutions.com/education'
                  },
                  {
                    display: 'DMS Insurance',
                    link: 'https://digitalmediasolutions.com/insurance'
                  },
                  {
                    display: 'DMS Performance Ad Market',
                    link: 'https://digitalmediasolutions.com/ad-market'
                  },
                  {
                    display: 'Ad Market Publisher Login',
                    link: 'https://network.w4.com/users/login',
                    target: '_blank'
                  }
                ]
              }
            ],
            [
              {
                header: 'About DMS',
                headerLink: 'https://digitalmediasolutions.com/about-dms',
                sublinks: [
                  {
                    display: 'Awards',
                    link: 'https://digitalmediasolutions.com/about-DMS#awards'
                  },
                  {
                    display: 'Careers',
                    link: 'https://careers.digitalmediasolutions.com/',
                    target: '_blank'
                  },
                  {
                    display: 'DMS Culture',
                    link: 'https://digitalmediasolutions.com/culture'
                  },
                  {
                    display: 'DMS Executive Team',
                    link: 'https://digitalmediasolutions.com/about-DMS#team'
                  },
                  {
                    display: 'Locations',
                    link: 'https://digitalmediasolutions.com/contact-us#offices'
                  },
                  {
                    display: 'Partners',
                    link: 'https://digitalmediasolutions.com/partners'
                  },
                  {
                    display: 'Technology Stack',
                    link: 'https://digitalmediasolutions.com/technology'
                  }
                ]
              }
            ],
            [
              {
                header: 'DMS Insights',
                headerLink: 'https://insights.digitalmediasolutions.com/',
                headerLinkTarget: '_blank',
                sublinks: [
                  {
                    display: 'Case Studies',
                    link: 'https://insights.digitalmediasolutions.com/dms-best-practices',
                    target: '_blank'
                  },
                  {
                    display: 'Newsroom',
                    link: 'https://digitalmediasolutions.com/newsroom'
                  },
                  {
                    display: 'Press Releases',
                    link: 'https://insights.digitalmediasolutions.com/press-releases',
                    target: '_blank'
                  }
                ]
              }
            ],
            [
              {
                header: 'Contact DMS',
                headerLink: 'https://digitalmediasolutions.com/contact-us',
                sublinks: [
                  {
                    display: '(800) 290-4010',
                    link: 'tel:800-290-4010'
                  },
                  {
                    display: 'ConsumerInquiries@DMSGroup.com',
                    link: 'mailto:ConsumerInquiries@DMSGroup.com'
                  }
                ]
              },
              {
                header: 'Privacy & Terms',
                sublinks: [
                  {
                    display: 'Privacy Policy',
                    link: 'https://digitalmediasolutions.com/privacy-policy'
                  }
                ]
              }
            ]
          ]
        },
        'digitalrewards': {
          colors: {
            navBackground: '#fff',
            primaryButtonBackground: '#83a846',
            primaryFontColor: '#fff',
            footerBackgroundColor: '#000',
            h5Color: 'white'
          },
          urls: {
            root: 'https://digitalrewards.io/',
            privacyPolicy: '/privacy-policy'
          },
          images: {
            logo: '/digital-rewards-logo-dblack.png',
            favicon: '/digitalrewards-favicon.ico'
          },
          contactInfo: {
            companyName: 'Digital Rewards',
            companyNameFull: 'Digital Rewards',
            companyNameShort: 'Digital Rewards',
            consumerInquiriesEmail: 'Consumerinquiries@stashsweeps.com',
            address: 'Digital Rewards 4000 W Montrose Ave 701 Chicago, IL 60641',
            supportNumber: '855-220-5553'
          },
          footerLinks: [
            [
              {
                header: 'Digital Rewards Policies',
                sublinks: [
                  {
                    display: 'Privacy Policy',
                    link: '/privacy'
                  },
                  {
                    display: 'California Privacy Notice',
                    link: '/privacy-notice'
                  },
                  {
                    display: 'Terms of Use',
                    link: '/terms'
                  }
                ]
              }
            ]
          ]
        },
        'whitestaremailllc': {
          colors: {
            navBackground: '#fff',
            primaryButtonBackground: '#469ea8',
            primaryFontColor: '#fff',
            footerBackgroundColor: '#000',
            h5Color: 'white'
          },
          urls: {
            root: 'https://insursimply.com',
            privacyPolicy: 'https://insursimply.com/priv.php'
          },
          images: {
            logo: 'https://images.quick-cdn.com/c8564e95175a81f502279cb36c104910.png',
            favicon: '/whitestaremail.ico'
          },
          contactInfo: {
            companyName: 'White Star Email',
            companyNameFull: 'White Star Email, LLC',
            companyNameShort: 'White Star Email',
            consumerInquiriesEmail: 'support@insursimply.com ',
            address: 'White Star Email, LLC 30190 US Highway 19N #1002 Clearwater, FL 33761',
            supportNumber: '800-647-6946'
          },
          footerLinks: [
            [
              {
                header: 'White Star Email Policies',
                sublinks: [
                  {
                    display: 'Privacy Policy',
                    link: 'https://insursimply.com/priv.php'
                  },
                  {
                    display: 'California Privacy Notice',
                    link: 'https://insursimply.com/california-privacy-notice.php'
                  },
                  {
                    display: 'Terms of Use',
                    link: 'https://insursimply.com/terms.php'
                  }
                ]
              }
            ]
          ]
        }
      }
    },
    recaptcha: false,
    loading: false,
    modal: true,
    thankYouModal: false,
    thankYouModalText: '',
    modalText: 'Verifying login',
    noDataFound: false,
    isSold: false,
    requestDncCompleted: sessionStorage.getItem('dnc-dnc-completed') !== '' ? sessionStorage.getItem('dnc-dnc-completed') : false,
    requestDnsCompleted: sessionStorage.getItem('dnc-dns-completed') !== '' ? sessionStorage.getItem('dnc-dns-completed') : false,
    requestDeleteCompleted: sessionStorage.getItem('dnc-delete-completed') !== '' ? sessionStorage.getItem('dnc-delete-completed') : false,
    errorMsg: '',
    error: false,
    isVerified: sessionStorage.getItem('dnc-isVerified') !== '' ? sessionStorage.getItem('dnc-isVerified') : false,
    lmsData: '',
    lmsDataObject: [],
    pii: {
      first_name: sessionStorage.getItem('dnc-pii-first_name') !== '' ? sessionStorage.getItem('dnc-pii-first_name') : '',
      last_name: sessionStorage.getItem('dnc-pii-last_name') !== '' ? sessionStorage.getItem('dnc-pii-last_name') : '',
      phone: sessionStorage.getItem('dnc-pii-phone') !== '' ? sessionStorage.getItem('dnc-pii-phone') : '',
      email: sessionStorage.getItem('dnc-pii-email') !== '' ? sessionStorage.getItem('dnc-pii-email') : '',
      userId: sessionStorage.getItem('dnc-pii-userId') !== '' ? sessionStorage.getItem('dnc-pii-userId') : '',
      verification_type: sessionStorage.getItem('dnc-pii-verification_type') !== '' ? sessionStorage.getItem('dnc-pii-verification_type') : ''
    },
    google_api_key: typeof process.env === 'object' && process.env.NODE_ENV === 'development' ? '6LdXebcUAAAAAE_htfm86hj1g7UxX9QqsrfMKMna' : '6LcxmcMUAAAAALuIY0ng5Bb6zHnEx8BSP6cJtbNG'
  },
  getters: {
    getPii: state => {
      return state.pii
    },
    getUserId: state => {
      return state.userId
    },
    getBrandData: (state) => () => {
      let hostname = window.location.hostname
      let branding = 'default'
      if (hostname.includes('digitalrewards')) {
        branding = 'digitalrewards'
      }
      if (hostname.includes('whitestaremailllc')) {
        branding = 'whitestaremailllc'
      }
      if (state.config.branding[branding]) {
        return {
          ...state.config.branding[branding],
          branding: branding
        }
      } else {
        return state.config.branding.default
      }
    }
  },
  mutations: { // synchronous
    loading (state, isLoading) {
      state.loading = isLoading
    },
    isVerified (state, isVerified) {
      sessionStorage.setItem('dnc-isVerified', isVerified)
      state.isVerified = isVerified
    },
    showModal (state, showModal) {
      state.modal = showModal
    },
    showThankYouModal (state, showModal) {
      state.thankYouModal = showModal
    },
    showThankYouModalText (state, options) {
      let dba = options.dba || 'Digital Media Solutions'
      let text = options.text
      let action = options.action
      if (text) {
        state.thankYouModalText = text
      } else {
        // use default template
        let thankYouModalTemplate = `Thank you for reaching out to  ${dba}. We have received your request for ${action}. We will process your request in accordance with applicable law. Further inquiries can be directed to consumerinquiries@dmsgroup.com. We appreciate your patience while we process your request.`
        state.thankYouModalText = thankYouModalTemplate
      }
    },
    noDataFound (state, noDataFound) {
      state.noDataFound = noDataFound
    },
    modalText (state, text) {
      state.modalText = text
    },
    dnsCompleted (state, isCompleted) {
      sessionStorage.setItem('dnc-dns-completed', isCompleted)
      state.requestDnsCompleted = isCompleted
    },
    dncCompleted (state, isCompleted) {
      sessionStorage.setItem('dnc-dnc-completed', isCompleted)
      state.requestDncCompleted = isCompleted
    },
    deleteCompleted (state, isCompleted) {
      sessionStorage.setItem('dnc-delete-completed', isCompleted)
      state.requestDeleteCompleted = isCompleted
    },
    storeUserId (state, userId) {
      state.pii.userId = userId
      sessionStorage.setItem('dnc-pii-userId', userId)
    },
    storeLmsData (state, data) {
      state.lmsData = JSON.stringify(data.pii, undefined, 4)
      let lmsDataTableObject = Object.keys(data.pii).map(function (key, index) {
        return {
          field: key,
          value: data.pii[key] === '' || data.pii[key] == null ? 'N/A' : data.pii[key]
        }
      })
      if (typeof data.buyer_names !== 'undefined' && data.buyer_names !== '') {
        state.isSold = true
      }
      state.lmsDataObject = lmsDataTableObject
    },
    setError (state, error) {
      state.error = error
    },
    setErrorMsg (state, msg) {
      state.errorMsg = msg
    },
    storePii (state, data) {
      state.pii = {
        first_name: data.data.first_name,
        last_name: data.data.last_name,
        phone: data.data.phone,
        email: data.data.email,
        verification_type: data.data.verification_type,
        trusted_form: data.trustedFormToken
      }
      sessionStorage.setItem('dnc-pii-first_name', data.data.first_name)
      sessionStorage.setItem('dnc-pii-last_name', data.data.last_name)
      sessionStorage.setItem('dnc-pii-phone', data.data.phone)
      sessionStorage.setItem('dnc-pii-email', data.data.email)
      sessionStorage.setItem('dnc-pii-verification_type', data.data.verification_type)
      sessionStorage.setItem('dnc-pii-trusted-form', data.trustedFormToken)
    },
    recaptcha (state, isValid) {
      state.recaptcha = isValid
    }
  },
  actions: { // async
    loginAction ({ commit, dispatch }, data) {
      commit('modalText', 'Logging in...')
      commit('showModal', true)

      login(data).then(function (response) {
        if (response !== false && typeof response.data.auth_token !== 'undefined' && response.data.auth_token !== '') {
          commit('storeUserId', response.data.auth_token)
          router.push('/confirmation')
        } else {
          commit('modalText', 'Sorry there has been an error, please try again.')
          bugsnagClient.notify('Error: loginAction failed')
          setTimeout(function () {
            commit('showModal', false)
            location.reload()
          }, 1500)
        }
      }).catch(response => {
        bugsnagClient.notify('Error: loginAction failed, invalid phone')
        commit('showModal', false)
      })
    },
    redirectToInfoView ({ dispatch }) {
      router.push('/info')
    },
    redirectToRequestView () {
      router.push('/request')
    },
    logOutRedirect () {
      router.push('/logout') // Start the entire process over again.
    },
    logOut ({ commit, dispatch }, msg) {
      commit('modalText', msg) // Need to abstract this a bit so it can re-used.
      sessionStorage.clear()
      setTimeout(function () {
        sessionStorage.clear()
        router.push('/') // Start the entire process over again.
      }, 3000)
    },
    dncRequest ({ commit, dispatch }) {
      commit('modalText', 'Processing your Do not Contact request')
      commit('showModal', true)

      requestDnc(this.state.pii.userId).then(function (response) {
        if (response.status === 201) {
          commit('dncCompleted', true) // Disables dnc btn
          commit('showModal', false)
          commit('showThankYouModal', true)
          commit('showThankYouModalText', { text: 'This message is verification that we have (a) received your request for Do not sell / Opt – out and (b) processed your request for “Right to Disclosure and Choice Regarding Sale of Personal Information to a Third Party.” In addition, please note that we have processed this request as an opt out for any future marketing.' })
        } else {
          bugsnagClient.notify('Error: dncRequest action failed')
          commit('modalText', 'There was an error processing your dnc request. Please try again later.')
        }
      })
    },
    /*
    dnsRequest ({ commit, dispatch }) {
      commit('modalText', 'Processing your Do not Sell request')
      commit('showModal', true)

      requestDns(this.state.pii.userId).then(function (response) {
        if (response.status === 201) {
          commit('dnsCompleted', true) // Disables dnc btn
          commit('showModal', false)
          commit('showThankYouModal', true)
          commit('showThankYouModalText', { action: 'Do not Sell' })
        } else {
          bugsnagClient.notify('Error: dnsRequest action failed')
          commit('modalText', 'There was an error processing your dns request. Please try again later.')
        }
      })
    },
    */
    requestDelete ({ commit, dispatch }) {
      commit('modalText', 'Processing your delete request')
      commit('showModal', true)

      requestDelete(this.state.pii.userId).then(function (response) {
        if (response.status === 201) {
          commit('deleteCompleted', true)
          commit('showModal', false)
          commit('showThankYouModal', true)
          commit('showThankYouModalText', { text: 'This message is verification that we have (a) received your request for Deletion and (b) processed your request for “Right to Request Deletion”.' })
        } else {
          bugsnagClient.notify('Error: delete action failed')
          commit('modalText', 'There was an error processing your delete request. Please try again later.')
        }
      })
    },
    verifyAction ({ commit, dispatch }, data) {
      commit('modalText', 'Verifying your request')
      commit('showModal', true)
      if (data === 'accepted') {
        commit('isVerified', true)
      }
      router.push('/request')
    },
    verifyTokenAction ({ commit, dispatch }, data) {
      commit('modalText', 'Submitting your token')
      commit('showModal', true)

      if (data.userId === '' || data.formData.token === '') {
        router.push('/logout')
        return false
      }

      verifyToken(data).then(function (response) {
        if (response.status === 201 && response.status !== 422) {
          commit('storeUserId', response.data.auth_token)
          router.push('/verify')
        } else {
          commit('showModal', false)
          if (response.status === 422) {
            commit('setErrorMsg', 'Incorrect confirmation token, try again.')
            commit('setError', true)
          }
        }
      })
    },
    getLead ({ commit, dispatch }) {
      commit('loading', true)
      commit('modalText', 'Searching for your data...')
      commit('showModal', true)

      fetchLead(this.state.pii.userId).then(function (response) {
        if (response.status === 200 && response.data.found === true) {
          commit('loading', false)
          commit('showModal', false)
          commit('storeLmsData', response.data)
        } else {
          commit('loading', false)
          commit('showModal', false)
          commit('noDataFound', true)
        }
      })
    }
    /*
    logAction ({ commit }, data) {
      // Ex: dispatch('logAction', { 'event': 'request_delete', 'success': true })
      let userId = this.state.pii.userId
      if (userId) {
        logEvent(data, userId)
      }
    }
    */
  }
})
